import Addon from '@shared/classes/addon';
import AppEvent from '@shared/classes/appEvent';
import Corner from '@shared/classes/corner';
import FastEvent from '@shared/classes/fastEvent';
import EpgEvent from '../../../classes/epgEvent';
import MainContext from '../context/mainContext';
import MediaProduction from '@shared/classes/mediaProduction';
import RegularEvent from '@shared/classes/regularEvent';
import { keepWatchingSelector } from '../../../store/slices/keepWatching.slice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { MutableRefObject, useContext, useEffect, useState } from 'react';
import {
  routerSelector,
  updateParams,
} from '../../../store/slices/router.slice';

function useKeepWatchingUpdateEvents({
  data,
  setListIndex,
  deleteRail,
  updateData,
}: {
  data: (
    | Addon
    | AppEvent
    | Corner
    | EpgEvent
    | FastEvent
    | MediaProduction
    | RegularEvent
    | undefined
  )[];
  setListIndex?: MutableRefObject<
    (newIndex: number, increment?: number | undefined) => void
  >;
  deleteRail: () => void;
  updateData: (
    newData: (
      | Addon
      | AppEvent
      | Corner
      | EpgEvent
      | FastEvent
      | MediaProduction
      | RegularEvent
      | undefined
    )[]
  ) => void;
}) {
  const dispatch = useAppDispatch();
  const { data: keepWatchingData } = useAppSelector(keepWatchingSelector);
  const { params } = useAppSelector(routerSelector);
  const { complete } = useContext(MainContext);
  const [eventsData, setData] = useState(data);

  useEffect(() => {
    setData(data);
  }, [data]);

  useEffect(() => {
    if (complete && eventsData?.length && !eventsData[0]?.dummy) {
      eventsData.forEach((item) => {
        const findEvent = keepWatchingData.find((keepWatching) => {
          return keepWatching.id === item?.eventId;
        });
        if (!findEvent) {
          const data = eventsData.filter((event) => {
            return event?.id !== item?.id;
          });
          if (data.length) {
            updateData(data);
            setData(data);
            if (params?.current?.updateKeepWatching) {
              setListIndex?.current(0, -1);
              dispatch(updateParams({ updateKeepWatching: false }));
            }
          } else {
            deleteRail();
          }
        }
      });
    }
  }, [complete, data, keepWatchingData, params]);

  return eventsData;
}

export default useKeepWatchingUpdateEvents;
